import { GET_PROYECTS } from "./actionType";


export function getProyects(){
    return{
        type: GET_PROYECTS
    }
}